import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext } from 'react';
const DensityContext = createContext('standard');
/**
 * Yoğunluk bağlamı: `data-density` özniteliği CSS değişkenlerini (satır/denetim yüksekliği, hücre boşluğu) değiştirir.
 * Bileşenler yükseklik prop'u almaz; tokens.css'teki değişkenleri kullanır (K-4).
 */
export function DensityProvider({ density, children, className, }) {
    return (_jsx(DensityContext.Provider, { value: density, children: _jsx("div", { "data-density": density, className: className, children: children }) }));
}
export function useDensity() {
    return useContext(DensityContext);
}
//# sourceMappingURL=density.js.map